export const MetricCards = ({ cards }) => {
  return (
    <div className="metric-row" data-testid="metric-row">
      {cards.map((item, index) => (
        <div className="metric" key={item.label} data-testid={`metric-card-${index}`}>
          <div className="metric-label">{item.label}</div>
          <div className="metric-val">{item.value}</div>
          <div className={`metric-badge ${item.badgeClass || "badge-gray"}`}>{item.badge}</div>
        </div>
      ))}
    </div>
  );
};
